<template lang="pug">
  #signUp.h-100
    appHeader(:title="'申請個人化服務'")
    router-view.content-body
</template>

<script>
import appHeader from '@/components/partials/AppHeader.vue';

export default {
  // 不管這邊打大小寫 顯示都會是以大寫形式為主
  name: 'UnbindMemberSignUpComponent',
  components: {
    appHeader
  }
};
</script>
